var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "46. Internet",
    id: "_46._Internet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.724,17A15.176,15.176,0,0,0,12,24a15.176,15.176,0,0,0,4.276-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,12a17.764,17.764,0,0,0,.271,3h9.458A17.764,17.764,0,0,0,17,12a17.764,17.764,0,0,0-.271-3H7.271A17.764,17.764,0,0,0,7,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.606,9H18.743A19.608,19.608,0,0,1,19,12a19.608,19.608,0,0,1-.257,3h4.863a11.618,11.618,0,0,0,0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9,7A12.025,12.025,0,0,0,15.03.4,17.922,17.922,0,0,1,18.324,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,12a19.608,19.608,0,0,1,.257-3H.394a11.618,11.618,0,0,0,0,6H5.257A19.608,19.608,0,0,1,5,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,17A12.025,12.025,0,0,0,8.97,23.6,17.922,17.922,0,0,1,5.676,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03,23.6A12.025,12.025,0,0,0,22.9,17H18.324A17.922,17.922,0,0,1,15.03,23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.276,7A15.176,15.176,0,0,0,12,0,15.176,15.176,0,0,0,7.724,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97.4A12.025,12.025,0,0,0,1.1,7H5.676A17.922,17.922,0,0,1,8.97.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSite);
export default __webpack_public_path__ + "static/media/web-site.d07ea768d72723978384bf2c75c7be2b.svg";
export { ForwardRef as ReactComponent };